<div class="celum-scrollbar dialog-content_native-scrolling-container" cdkScrollable>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
